import { useNavigate, useParams } from '@exam-management/router';
import {
  Button,
  Flex,
  Menu,
  type ButtonProps,
  AddRoundedIcon,
  ExpandMoreRoundedIcon,
  DescriptionOutlinedIcon,
  LibraryBooksOutlinedIcon,
  MenuItem,
  ListItemIcon,
  Text,
} from '@shared/components';
import { useState } from 'react';

export default function AddNewQContentButton(props: Readonly<ButtonProps>) {
  const { structureId } = useParams('/qbank-structures/:structureId');
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const navigate = useNavigate();

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleClickSingle = () => {
    navigate(`/qbank-structures/:structureId/qcontents/single/create`, {
      params: { structureId },
    });
  };

  const handleClickItemSet = () => {
    navigate(`/qbank-structures/:structureId/qcontents/item-set/create`, {
      params: { structureId },
    });
  };

  return (
    <>
      <Button
        {...props}
        onClick={handleOpenMenu}
        startIcon={<AddRoundedIcon />}
        endIcon={<ExpandMoreRoundedIcon />}
      />
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleCloseMenu}
        sx={(theme) => ({
          ' .MuiList-root': {
            p: theme.spacing(0),
          },
          '.MuiPaper-root': {
            borderRadius: theme.shape.rounded(2),
            ml: theme.spacing(1.5),
          },
        })}
      >
        <Flex
          sx={{
            flexDirection: 'column',
            width: '168px',
          }}
        >
          <MenuItem sx={(theme) => ({ p: theme.spacing(2, 3.5) })} onClick={handleClickSingle}>
            <ListItemIcon
              sx={{
                color: (theme) => theme.palette.text.primary,
              }}
            >
              <DescriptionOutlinedIcon fontSize='small' />
            </ListItemIcon>
            <Text variant='body2Semibold'>Single</Text>
          </MenuItem>
          <MenuItem sx={(theme) => ({ p: theme.spacing(2, 3.5) })} onClick={handleClickItemSet}>
            <ListItemIcon
              sx={{
                color: (theme) => theme.palette.text.primary,
              }}
            >
              <LibraryBooksOutlinedIcon fontSize='small' />
            </ListItemIcon>
            <Text variant='body2Semibold'>Item Set</Text>
          </MenuItem>
        </Flex>
      </Menu>
    </>
  );
}
